/** Client-spec dropdown values for the machine master module. */

export const MACHINE_PROJECT_TYPES = [
  'COMMERCIAL',
  'RESIDENTIAL',
  'INDUSTRIAL',
  'INFRASTRUCTURE',
  'GOVERNMENT',
];

export const MACHINE_CATEGORIES = [
  'CONSTRUCTION_EQUIPMENT',
  'EARTHMOVING_EQUIPMENT',
  'LIFTING_EQUIPMENT',
  'MATERIAL_HANDLING',
  'CONCRETE_EQUIPMENT',
  'ROAD_CONSTRUCTION',
  'COMPACTION_EQUIPMENT',
  'POWER_TOOLS',
  'SURVEYING_EQUIPMENT',
];

export const MACHINE_OWNER_TYPES = [
  'PRINCIPAL_OWNER',
  'SUBCONTRACTOR',
  'VENDOR',
  'RENTAL_COMPANY',
];

export const MACHINE_LEASE_STATUS = ['OWNED', 'LEASED', 'RENTED'];

export const MACHINE_OPERATIONAL_STATUS = [
  'OPERATIONAL',
  'UNDER_MAINTENANCE',
  'IDLE',
  'NON_OPERATIONAL',
  'RETIRED',
];

export const MACHINE_CONDITIONS = ['EXCELLENT', 'GOOD', 'FAIR', 'POOR'];

export const MACHINE_WARRANTY_STATUS = ['ACTIVE', 'EXPIRED', 'NOT_APPLICABLE'];

export const MACHINE_INSURANCE_STATUS = ['INSURED', 'UNINSURED', 'PENDING'];

export const MACHINE_FUEL_TYPES = ['DIESEL', 'PETROL', 'ELECTRIC', 'HYBRID', 'CNG', 'NA'];

export interface MachineDropdownConfig {
  labelKey: string;
  formControl: string;
  options: string[];
  required: boolean;
}

export const MACHINE_DROPDOWNS: MachineDropdownConfig[] = [
  { labelKey: 'PROJECT_TYPE', formControl: 'projectType', options: MACHINE_PROJECT_TYPES, required: true },
  { labelKey: 'MACHINE_CATEGORY', formControl: 'machineCategory', options: MACHINE_CATEGORIES, required: true },
  { labelKey: 'OWNER_TYPE', formControl: 'ownerType', options: MACHINE_OWNER_TYPES, required: true },
  { labelKey: 'LEASE_STATUS', formControl: 'leaseStatus', options: MACHINE_LEASE_STATUS, required: true },
  { labelKey: 'OPERATIONAL_STATUS', formControl: 'operationalStatus', options: MACHINE_OPERATIONAL_STATUS, required: true },
  { labelKey: 'CONDITION', formControl: 'condition', options: MACHINE_CONDITIONS, required: false },
  { labelKey: 'WARRANTY_STATUS', formControl: 'warrantyStatus', options: MACHINE_WARRANTY_STATUS, required: false },
  { labelKey: 'INSURANCE_STATUS', formControl: 'insuranceStatus', options: MACHINE_INSURANCE_STATUS, required: false },
  { labelKey: 'FUEL_TYPE', formControl: 'fuelType', options: MACHINE_FUEL_TYPES, required: false },
];
